import { Component, OnInit, OnDestroy } from '@angular/core';
import {MessageService,AuthService} from 'src/app/services'
@Component({
  selector: 'bart-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit,OnDestroy  {
  public errorMessage = ' ';
  public errorType = '';
  public serviceNowUrl = '';

  constructor(private messageService: MessageService, private authService: AuthService) { }

  ngOnInit() {
    this.serviceNowUrl = this.authService.getServiceNowRequestUrl();
    this.errorType="400" 
    localStorage.clear();
    this.messageService.currentMessage.subscribe(message => 
      {
       this.errorMessage = message
        if(this.errorMessage!=null && this.errorMessage!=undefined && this.errorMessage.length>0)
        {
          this.errorMessage=this.errorMessage.replace(/(?:\r\n|\r|\n)/g, '<br>');
          var arrmsg=this.errorMessage.split(":");
          if(arrmsg.length>0 && arrmsg[1].length>0)
          {
            this.errorType=arrmsg[0];
            this.errorMessage=arrmsg[1];
          }
          else
          {
            this.errorMessage=arrmsg[0];
          }
        }
      });
  }
  ngOnDestroy() {
    // this.errorMessage="";
    // this.errorType="";
 }
 logout() {
  // localStorage.clear();
  this.authService.signOut();
 }
}
